import { useTranslation } from 'react-i18next';
import { RegistryGlobalSummaryLegacy } from '../../../types';

interface GlobalTabLegacyProps {
  globalSummary: RegistryGlobalSummaryLegacy;
}

const FIELD_KEYS: Array<{ field: keyof RegistryGlobalSummaryLegacy; i18nKey: string }> = [
  { field: 'world_setting', i18nKey: 'global.worldSetting' },
  { field: 'plot_driver_mode', i18nKey: 'global.plotDriverMode' },
  { field: 'main_conflicts', i18nKey: 'global.mainConflicts' },
  { field: 'minor_conflicts', i18nKey: 'global.minorConflicts' },
  { field: 'tone', i18nKey: 'global.tone' },
  { field: 'narrative_perspective', i18nKey: 'global.narrativePerspective' },
  { field: 'ending_type', i18nKey: 'global.endingType' },
  { field: 'total_acts', i18nKey: 'global.totalActs' },
];

// 旧版（legacy）世界观渲染：扁平 8 字段。保留原实现，供存量项目展示。
export default function GlobalTabLegacy({ globalSummary }: GlobalTabLegacyProps) {
  const { t } = useTranslation('scriptSummary');

  return (
    <div className="registry-kv-list registry-global-list">
      {FIELD_KEYS.map(({ field, i18nKey }) => {
        const value = globalSummary[field];
        if (value === undefined || value === null || value === '') return null;
        return (
          <div key={field} className="registry-kv-row">
            <span className="registry-kv-key">{t(i18nKey)}</span>
            <span className="registry-kv-value">{String(value)}</span>
          </div>
        );
      })}
    </div>
  );
}
